export default __webpack_public_path__ + "static/media/patrocinadores_resized.30efd6d5.gif";